import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgMaterialModule, SharedModule } from 'shared';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { SquirrelFooterComponent } from './squirrel-footer/squirrel-footer.component';
import { SquirrelLayoutComponent } from './squirrel-layout.component';
import { SquirrelLayoutRouts } from './squirrel-layout.routing';
import { SquirrelSideNavComponent } from './squirrel-side-nav/squirrel-side-nav.component';
import { SquirrelTopNavComponent } from './squirrel-top-nav/squirrel-top-nav.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SquirrelAuthenticatedComponent } from './squirrel-authenticated/squirrel-authenticated.component';
import { SquirrelChartsComponent } from './squirrel-charts/squirrel-charts.component';
import { SquirrelDashboardComponent } from './squirrel-dashboard/squirrel-dashboard.component';
import { SqChartsComponent } from './sq-charts/sq-charts.component';
import { AgGridModule } from 'ag-grid-angular';
import { SquirrelCardComponent } from './squirrel-charts/cards/squirrel-card/squirrel-card.component';
import { HeaderComponent } from './header/header.component';
//import { SelectTenantComponent } from 'projects/admin/src/lib/manage-tenants/select-tenant/select-tenant.component';
import { AdminModule } from 'admin';
//import { SqMatSelectInputComponent } from './squirrel-charts/sq-mat-select-input/sq-mat-select-input.component';
//import { SquirrelCalendarComponent } from './squirrel-charts/squirrel-calendar/squirrel-calendar.component';



// import { FlatpickrModule } from 'angularx-flatpickr';
// import { CalendarModule, DateAdapter } from 'angular-calendar';
// import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
//import { EventEditDialogComponent } from './squirrel-charts/squirrel-calendar/event-edit-dialog/event-edit-dialog.component';

@NgModule({
  declarations: [
    SquirrelLayoutComponent,
    SquirrelTopNavComponent,
    SquirrelSideNavComponent,
    SquirrelFooterComponent,
    UserProfileComponent,
    AppSettingsComponent,
    //UserChangePasswordComponent,
    SquirrelAuthenticatedComponent,
    SquirrelChartsComponent,
    SquirrelDashboardComponent,
    SqChartsComponent,
    SquirrelCardComponent,
    HeaderComponent,
   
    //SquirrelCalendarComponent,
    //EventEditDialogComponent
  ],
  imports: [
    AdminModule,
    CommonModule,
    FormsModule,
    NgMaterialModule,
    // FlatpickrModule.forRoot(),
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // }),
    SharedModule,
    RouterModule.forChild(SquirrelLayoutRouts),
    AgGridModule
  ],
  exports: [
    SquirrelLayoutComponent
  ],
  providers:[DatePipe]
})
export class SquirrelLayoutModule { }
